export const logRocketApiKey: string = 'xjnijt/tikkalcasino';
